import { render } from "./CampaignsTableActions.vue?vue&type=template&id=4d08f0bc"
import script from "./CampaignsTableActions.vue?vue&type=script&lang=js"
export * from "./CampaignsTableActions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__